import React from 'react';
import { useState, useEffect } from 'react';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import { motion } from 'framer-motion';

import cheddar from '../../assets/cheddar.png';
import tidynote from '../../assets/tidynote.png';
import dulynoted from '../../assets/dulynoted.png';

import AppWrap from '../../wrappers/AppWrap'

import './Work.scss';

const Work = () => {
  // const [activeFilter, setActiveFilter] = useState();
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1});

  // const handleWorkFilter = (item) => {

  // };

  const filterWork = [
    { name: 'Cheddar', title: 'Cheddar', imgUrl: cheddar, projectLink: 'https://cheddar-sp.herokuapp.com/', codeLink: 'https://github.com/andrwtran/cheddar', description: ' A budgeting app', tags: ['React', 'Flask'] },
    { name: 'TidyNote', title: 'TidyNote', imgUrl: tidynote, projectLink: 'https://tidynote-flask-app.herokuapp.com/', codeLink: 'https://github.com/JamesRR91/TidyNote', description: ' A note taking app', tags: ['React', 'Flask'] },
    { name: 'Duly Noted', title: 'Duly Noted', imgUrl: dulynoted, projectLink: 'https://duly-noted-sp.herokuapp.com/', codeLink: 'https://github.com/andrwtran/duly-noted', description: ' A note taking app', tags: ['React', 'Express'] }
  ];

  return (
    <>
      <h2 className='head-text'><span>My Projects</span></h2>

      {/* <div className="app__work-filter">
        {['React', 'Flask', 'Express'].map((item, index) => (
          <div
            key={index}
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active' : ''}`}
          >
            {item}
          </div>
        ))}
      </div> */}

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((work, index) => (
          <div className="app__work-item app__flex" key={index}>
            <div className='app__work-img app_flex'>
              <img src={work.imgUrl} alt={work.name} />

              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0 }}
                className="app__work-hover app__flex"
              >
                <a href={work.projectLink} target="_blank" rel="noreferrer">
                  <motion.div
                  whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
                <a href={work.codeLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>
            <div className='app__work-content app__flex'>
              <h4 className='bold-text'>{work.title}</h4>
              <p className='p-text' style={{ marginTop: 10} }>{work.description}</p>
              <div className='app__work-tag app__flex'>
                <p className='p-text'>{work.tags[0] + '/' + work.tags[1]}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </>
  );
}

export default AppWrap(Work, 'work');
